import { message } from 'antd';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import baseuri from '../../baseuri';

export const getRemittanceReport = createAsyncThunk(
	'global-webhooks/getRemittanceReport',
	async (params: any) => {
		try {
			const res = await baseuri.get(
				'../hooks/webhooks/switchwallet/get-remittance-report',
				{ params }
			);
			return res.data.data;
		} catch (error: any) {
			message.error(error?.response?.data?.message);
			throw new Error(error);
		}
	}
);

export const getRemittanceCompanies = createAsyncThunk(
	'global-webhooks/getRemittanceCompanies',
	async () => {
		const res = await baseuri.get(
			'../hooks/webhooks/switchwallet/remittance-companies'
		);
		return res.data.data;
	}
);

export const getCurrentRemittanceMerchant = createAsyncThunk(
	'global-webhooks/getCurrentRemittanceMerchant',
	async (params: any) => {
		console.info('params', params);

		return params;
	}
);

export const getSwitchWalletBalances = createAsyncThunk(
	'global-webhooks/getSwitchWalletBalances',
	async (params: any) => {
		const res = await baseuri.get(
			'../hooks/webhooks/switchwallet/wallet-balances',
			{ params }
		);
		return res.data.data;
	}
);

export const triggerSwitchWalletRemittance = createAsyncThunk(
	'global-webhooks/triggerSwitchWalletRemittance',
	async (payload: any) => {
		try {
			const res = await baseuri.post(
				'../hooks/webhooks/switchwallet/trigger-remittance',
				payload
			);
			message.success(res.data.data.data.message);
			return res.data.data;
		} catch (error: any) {
			message.error(error?.response?.data?.message);
			throw new Error(error);
		}
	}
);

export const rescanSwitchWalletTransaction = createAsyncThunk(
	'global-webhooks/rescanSwitchWalletTransaction',
	async (params: any) => {
		try {
			const res = await baseuri.get(
				'../hooks/webhooks/switchwallet/rescan-transaction',
				{ params }
			);
			message.success(res.data.data.data.message);
			return res.data.data;
		} catch (error: any) {
			message.error(error?.response?.data?.message);
			throw new Error(error);
		}
	}
);

export const getUserTypes = createAsyncThunk('users/getUserTypes', async () => {
	const res = await baseuri.get('/admin/user-types/user-types');
	return res.data.data;
});

const globalWebhooks = createSlice({
	name: 'global-webhooks',
	initialState: {
		userTypes: [],
		custodialFunctionUsers: {
			itemsList: [],
			paginator: {
				itemCount: 0,
				currentPage: 1,
				perPage: 50,
			},
		},
		loadingReport: false,
		remittanceReport: {
			data: {
				currency: '',
				remittances: [],
				reportGeneratedAt: '',
				reportId: '',
				reportPeriodEnd: '',
				reportPeriodStart: '',
				totalAmount: 0,
				totalSuccessfulRemittances: 0,
				totalFundingTransactions: 0,
				totalFundingValue: 0,
				totalRemittanceValue: 0,
				remittableTransactions: 0,
				transactions: [],
			},
			message: '',
			status: 0,
		},
		loadingCompanies: false,
		remittanceCompanies: {
			data: [],
			message: '',
			status: 0,
		},
		currentRemittanceCompany: { id: '', businessName: '' },
		loadingBalance: false,
		walletBalances: {
			data: {
				summary: {
					totalWallets: 0,
					totalRemittable: 0,
					totalNonRemittable: 0,
					remittablePercentage: 0,
					totalBalanceValue: 0,
					totalRemittableValue: 0,
					totalNonRemittableValue: 0,
					balanceByCurrency: [],
				},
				balances: [],
			},
		},
		triggeringRemittance: false,
		rescanningTransaction: false,
	},
	reducers: {},
	extraReducers: (builder) =>
		builder
			.addCase(getUserTypes.fulfilled, (store, action) => {
				const state = store;
				state.userTypes = action.payload;
			})
			.addCase(getRemittanceReport.pending, (store) => {
				const state = store;
				state.loadingReport = true;
			})
			.addCase(getRemittanceReport.fulfilled, (store, action) => {
				const state = store;
				state.remittanceReport = action.payload;
				state.loadingReport = false;
			})
			.addCase(getRemittanceCompanies.pending, (store) => {
				const state = store;
				state.loadingCompanies = true;
			})
			.addCase(getRemittanceCompanies.fulfilled, (store, action) => {
				const state = store;
				state.remittanceCompanies = action.payload;
				state.loadingCompanies = false;
			})
			.addCase(getCurrentRemittanceMerchant.fulfilled, (store, action) => {
				const state = store;
				state.currentRemittanceCompany = action.payload;
			})
			.addCase(getSwitchWalletBalances.pending, (store) => {
				const state = store;
				state.loadingBalance = true;
			})
			.addCase(getSwitchWalletBalances.fulfilled, (store, action) => {
				const state = store;
				state.walletBalances = action.payload.data;
				state.loadingBalance = false;
			})
			.addCase(triggerSwitchWalletRemittance.pending, (store) => {
				const state = store;
				state.triggeringRemittance = true;
			})
			.addCase(triggerSwitchWalletRemittance.fulfilled, (store) => {
				const state = store;
				state.triggeringRemittance = false;
			})
			.addCase(rescanSwitchWalletTransaction.pending, (store) => {
				const state = store;
				state.rescanningTransaction = true;
			})
			.addCase(rescanSwitchWalletTransaction.fulfilled, (store) => {
				const state = store;
				state.rescanningTransaction = false;
			})
			.addCase(rescanSwitchWalletTransaction.rejected, (store) => {
				const state = store;
				state.rescanningTransaction = false;
			}),
});

export default globalWebhooks.reducer;
